export default __webpack_public_path__ + "images/VWTextCarUI-Light.442b9e14.ttf";